import { render, staticRenderFns } from "./reisen-metadata-card-plan-zimmerkontingente.vue?vue&type=template&id=3c2ae7b5&scoped=true"
import script from "./reisen-metadata-card-plan-zimmerkontingente.vue?vue&type=script&lang=js"
export * from "./reisen-metadata-card-plan-zimmerkontingente.vue?vue&type=script&lang=js"
import style0 from "./reisen-metadata-card-plan-zimmerkontingente.vue?vue&type=style&index=0&id=3c2ae7b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2ae7b5",
  null
  
)

export default component.exports